import { RootState } from '@store/rootReducer'

export const selectUser = (state: RootState) => state.editor.user.user
export const selectUserIsPremium = (state: RootState) => state.editor.user.userIsPremium
export const selectUserIsSuper = (state: RootState) => state.editor.user.userIsSuper
export const selectUserRemainingCredits = (state: RootState): number => {
  const rawCredits = state.editor.user.user?.remaining_credits
  const numericCredits = Number(rawCredits)
  return Number.isFinite(numericCredits) ? numericCredits : 0
}
export const selectOpenModalTryPremium = (state: RootState) => state.editor.user.openModalTryPremium
export const selectIntroVideoDetail = (state: RootState) => state.editor.user.introVideoDetail
export const selectIsSampleUser = (state: RootState) => state.editor.user.isSampleUser
export const selectUserStore = (state: RootState) => state.editor.user
export const selectOpenModalOutOfCredits = (state: RootState) => state.editor.user.openModalOutOfCredits
